import { z } from "zod";


export const CardInfoSchema = z.object({
  id: z.number(),
  pan: z.string(),
  exp_date: z.string(),
  is_chosen: z.boolean()
});

export const CardResponseSchema = z.object({
  payment_url: z.string()
});

export const SetDefaultCardRequestSchema = z.object({
  card_id: z.number()
});

export const RemoveCardRequestSchema = z.object({
  card_id: z.number()
});

export const CardListResponseSchema = z.object({
  cards: z.array(CardInfoSchema)
});

